import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const SDKSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default SDKSVG;
